import * as React from "react";
import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { useApiClient } from "../../../api";

export const AssignStudentDialog = ({
  open,
  setOpen,
  schoolClass,
  students,
  onReload = () => {},
}) => {
  const ApiClient = useApiClient();
  const [student, setStudent] = useState({});

  const handleSubmit = async () => {
    try {
      const response = await ApiClient.schools.assignStudentsToClass({
        students: [student.id],
        schoolClass: schoolClass.id,
      });
      if (response.success) {
        setOpen(false);
        onReload();
      } else {
        console.log("DO SOMETHING");
      }
    } catch (error) {
      console.error("Failed to assign student", error);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      slotProps={{
        paper: {
          component: "form",
          sx: { backgroundImage: "none" },
        },
      }}
    >
      <DialogTitle>Add Student to Class</DialogTitle>
      <DialogContent>
        <Autocomplete
          disablePortal
          autoSelect
          options={students}
          value={student}
          onChange={(_, newValue) => setStudent(newValue)}
          getOptionLabel={(option) => option?.identifier || ""}
          isOptionEqualToValue={(option, value) => option?.id === value?.id}
          fullWidth
          slotProps={{
            clearIndicator: {
              sx: {
                border: "none",
                boxShadow: "none",
                "&:hover": {
                  background: "transparent",
                },
                height: 5,
              },
            },
          }}
          renderInput={(params) => (
            <TextField {...params} placeholder="Student" />
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant={"outlined"}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant={"contained"}
          disabled={!schoolClass || !student}
        >
          Assign
        </Button>
      </DialogActions>
    </Dialog>
  );
};
